export default __webpack_public_path__ + "static/media/stars.94ba6f5c.svg";